// removed by extract-text-webpack-plugin
module.exports = {"right":"related-views-button__right"};


//////////////////
// WEBPACK FOOTER
// ./src/components/view-pane/related-views-button.scss
// module id = 1233
// module chunks = 0